var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{ref:"modal",attrs:{"title":_vm.title},on:{"submit":function($event){return _vm.$emit('confirm')}}},[_c('p',[_vm._t("default")],2),_c('input',{staticStyle:{"opacity":"0","height":"1px"},attrs:{"autofocus":""}}),_c('button',{staticClass:"button right",attrs:{"type":"submit"}},[_vm._v("Confirm")])])
}
var staticRenderFns = []

export { render, staticRenderFns }